import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

const API_URL = '/cargo/api/requisites';

export interface BankAccount {
  currency: string;
  account: string;
}

export interface CompanyRequisites {
  id?: number;
  userId?: number;
  bin?: string;
  legalAddress?: string;
  bankAccounts?: BankAccount[];
  bankName?: string;
  bik?: string;
  contractSignerPosition?: string;
  contractSignerName?: string;
}

@Injectable({
  providedIn: 'root'
})
export class RequisitesService {
  constructor(private http: HttpClient) {}

  getMyRequisites(): Observable<CompanyRequisites> {
    return this.http.get<CompanyRequisites>(`${API_URL}/my`);
  }

  saveMyRequisites(requisites: CompanyRequisites): Observable<CompanyRequisites> {
    return this.http.post<CompanyRequisites>(`${API_URL}/my`, requisites);
  }

  deleteMyRequisites(): Observable<void> {
    return this.http.delete<void>(`${API_URL}/my`);
  }

  /**
   * Получить реквизиты компании по ID пользователя
   * @param userId ID пользователя
   */
  getRequisitesByUserId(userId: number): Observable<CompanyRequisites> {
    return this.http.get<CompanyRequisites>(`${API_URL}/${userId}`);
  }
}
